// extracted by mini-css-extract-plugin
export var smallSpinner = "_qr-0";